/**
 * Catalyst Public API (api.nscatalyst.com) integration settings (admin-only).
 *
 * A single API key + base URL connect PSA to the read-only Catalyst Public API so admins
 * can browse its endpoints from the integration page. The key is stored encrypted at rest
 * and never returned; the page tests connectivity and proxies read-only GET requests.
 */
/* -------------------------------------------------------------------------- */
/* NetSuite account-name sync                                                  */
/* -------------------------------------------------------------------------- */
/** Outcome of a NetSuite account-name sync run. */
export const CATALYST_PORTAL_SYNC_OUTCOMES = ['ok', 'partial', 'failed'];
/** Scheduler bounds for the account-name sync (minutes). */
export const CATALYST_PORTAL_MIN_INTERVAL_MINUTES = 15;
export const CATALYST_PORTAL_MAX_INTERVAL_MINUTES = 10_080;
export const CATALYST_PORTAL_DEFAULT_INTERVAL_MINUTES = 1_440;
/* -------------------------------------------------------------------------- */
/* Agreement ↔ portal tenant billing binding                                   */
/* -------------------------------------------------------------------------- */
/** Billing source PSA identifies itself with when binding a tenant. */
export const CATALYST_PORTAL_BILLING_SOURCE = 'catalyst_psa';
/** Agreement subtype (case/space-insensitive) that bills through ConnectBooster. */
export const CATALYST_PORTAL_CONNECTBOOSTER_SUBTYPE = 'connectbooster';
/**
 * Resolves the portal-billing mode from the agreement's type + subtype. Shared so the API
 * and the UI agree on which agreements offer portal billing at all.
 */
export function agreementPortalBillingMode(type, subtypeName) {
    if (type === 'managed_services')
        return 'managed_services';
    if (type === 'product_subscription') {
        const subtype = (subtypeName ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
        if (subtype === CATALYST_PORTAL_CONNECTBOOSTER_SUBTYPE)
            return 'connectbooster';
    }
    return 'none';
}
/** Settlement states PSA can set from the Portal Billing tab. */
export const AGREEMENT_PORTAL_SETTLEMENT_STATES = ['ready', 'settled'];
/* -------------------------------------------------------------------------- */
/* Caia tier → customer type sync                                              */
/* -------------------------------------------------------------------------- */
/** Customer types PSA maintains from the portal's Caia billing tier. */
export const CATALYST_PORTAL_TRIAL_TYPE_NAME = 'Caia Trial';
export const CATALYST_PORTAL_PAID_TYPE_NAME = 'Caia Paid';
/**
 * Turns a `role_flags` key into a display label. Portal keys are snake_case and use the
 * product's internal AI codename, which reads as "AI" everywhere in PSA.
 */
export function portalRoleFlagLabel(key) {
    return key
        .split(/[_\s-]+/)
        .filter(Boolean)
        .map((word) => {
        const lower = word.toLowerCase();
        if (lower === 'liara' || lower === 'ai')
            return 'AI';
        if (lower === 'id')
            return 'ID';
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
        .join(' ');
}
//# sourceMappingURL=catalyst-portal.js.map